import React from 'react';
import { TextField } from '@mui/material';

function InputUrl({ sx = { marginTop: '5px' }, ...params }) {
  return <TextField {...params} type="url" sx={sx} fullWidth variant="outlined" />;
}

export default InputUrl;
